import { render } from "./chat-extra-messages.vue?vue&type=template&id=5c8010bc"
import script from "./chat-extra-messages.vue?vue&type=script&lang=js"
export * from "./chat-extra-messages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__